/**
 * Fee amounts in TZS.
 *
 * NOT SERVED BY THE API. The only fees the backend exposes are the licence
 * sub-category `baseFee` / `managementFee` returned by GET /license-categories
 * (LicenseSubcategoryDTO) - those are read from the API in the licence wizard.
 * There is no endpoint for the investment application fee or for either
 * inspection fee: /countries/{id}/zones (Zone) carries no fee field and no
 * fee-calculation endpoint is exposed for investments, so the values below are
 * client-side constants and must be kept in step with the published ZCT fee
 * schedule by hand.
 *
 * They are declared here once so the payment step and the summary step of a
 * wizard can never disagree about what is being charged.
 */

/**
 * Charged up front, at step 1 of the investment wizard. This is the approval
 * letter fee shown on the submission summary.
 */
export const INVESTMENT_APPLICATION_FEE = 50000;

/** Inspection fee charged at submission, higher inside the special zones. */
export const INVESTMENT_INSPECTION_FEE = 150000;
export const INVESTMENT_SPECIAL_ZONE_INSPECTION_FEE = 200000;

/** Zones charged the higher inspection fee. */
export const INVESTMENT_SPECIAL_ZONES = ["Fumba Zone", "Amaan Industrial Park"];

export function investmentInspectionFee(zone?: string): number {
    return INVESTMENT_SPECIAL_ZONES.includes(zone ?? "")
        ? INVESTMENT_SPECIAL_ZONE_INSPECTION_FEE
        : INVESTMENT_INSPECTION_FEE;
}

/** Inspection fee for a licence application. */
export const LICENCE_INSPECTION_FEE = 250000;
